"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaConstructionPreprocessRequestToJSON = exports.RosettaConstructionPreprocessRequestFromJSONTyped = exports.RosettaConstructionPreprocessRequestFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaConstructionPreprocessRequestFromJSON(json) {
    return RosettaConstructionPreprocessRequestFromJSONTyped(json, false);
}
exports.RosettaConstructionPreprocessRequestFromJSON = RosettaConstructionPreprocessRequestFromJSON;
function RosettaConstructionPreprocessRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'network_identifier': _1.NetworkIdentifierFromJSON(json['network_identifier']),
        'operations': (json['operations'].map(_1.RosettaOperationFromJSON)),
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : json['metadata'],
        'max_fee': !runtime_1.exists(json, 'max_fee') ? undefined : (json['max_fee'].map(_1.RosettaMaxFeeAmountFromJSON)),
        'suggested_fee_multiplier': !runtime_1.exists(json, 'suggested_fee_multiplier') ? undefined : json['suggested_fee_multiplier'],
    };
}
exports.RosettaConstructionPreprocessRequestFromJSONTyped = RosettaConstructionPreprocessRequestFromJSONTyped;
function RosettaConstructionPreprocessRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'network_identifier': _1.NetworkIdentifierToJSON(value.network_identifier),
        'operations': (value.operations.map(_1.RosettaOperationToJSON)),
        'metadata': value.metadata,
        'max_fee': value.max_fee === undefined ? undefined : (value.max_fee.map(_1.RosettaMaxFeeAmountToJSON)),
        'suggested_fee_multiplier': value.suggested_fee_multiplier,
    };
}
exports.RosettaConstructionPreprocessRequestToJSON = RosettaConstructionPreprocessRequestToJSON;
//# sourceMappingURL=RosettaConstructionPreprocessRequest.js.map